

import { createBrowserRouter } from 'react-router-dom';
import { RouterProvider } from 'react-router';
import { isMobile } from 'react-device-detect';
import Main from '../src/Components/Main/Main'
import DailyRentalComponent from '../src/Components/DailyRentals/DailyRentalComponent'
import MontlyRentalComponent from '../src/Components/MontlyRentals/MontlyRentalComponent'
import LandingPageLayout from '../src/Components/LandingPageLayout'
import Places from '../src/Components/Places/Place'
import BookingSummary from './Components/Summary/BookingSummary';
import MembershipCard from './Components/Summary/MemberShipCard';
import Terms from './Components/T&C/Terms';
import ProductData from './Components/Products/ProductData';
import Offer from '../src/Components/Offer/Offer';
import FranchiseComponent from '../src/Components/Franchise/FranchiseComponent';
import AboutMOW from './Components/SideBarLayout/AboutMOW';
import Layout from './Components/SideBarLayout/Layout';
import YourTrip from '../src/Components/SideBarLayout/YourTrip';
import Payments from '../src/Components/SideBarLayout/Payments';
import YourBooking from '../src/Components/SideBarLayout/YourBooking';
import Refer from '../src/Components/SideBarLayout/Refer';
import Wallet from '../src/Components/SideBarLayout/Wallet';
import ContactComponent from './Components/Contact/ContactComponent';
import BlogComponent from '../src/Components/Blog/BlogComponent';
import ProfileLayout from '../src/Components/MyProfile/ProfileLayout';
import ProfileComponent from '../src/Components/MyProfile/MyProfile/ProfileComponent';
import BookingCard from '../src/Components/MyProfile/MyRide/BookingCard';
import RideDetails from '../src/Components/MyProfile/MyRide/RideDetails';
import Notification from '../src/Components/MyProfile/ProfileInfo/Notification';
import MyReferal from '../src/Components/MyProfile/ProfileInfo/MyReferal';
import WalletAmount from '../src/Components/MyProfile/ProfileInfo/WalletAmout';
import WalletHistory from '../src/Components/MyProfile/ProfileInfo/WalletHistory';
import MyBooking from '../src/Components/MyProfile/MyBooking/MyBooking';
import ChooseLocation from './Components/NavBar/ChooseLocation';
import NextRide from './Components/Products/NextRide';
import FilterComponent from './Components/BikeFilter/FilterComponent';
import AccesoriesComponent from './Components/Accesories/AccesoriesComponent';
import SignIn from './Components/Account/SignIn';
import Verify from './Components/Account/Verify';
import Login from './Components/Account/Login';
import Logout from '../src/Components/Account/Logout';
import MoreDetails from './Components/MyProfile/MyBooking/MoreDetails';
import MobileMoreDetails from '../src/Components/Mobile Components/MyProfileMobileView/MyBookings/MobileMoreDetails';
import DailyRental from './Components/DailyRentals/DailyRental';
import MontlyRental from './Components/MontlyRentals/MontlyRental';
import OtpVerificationPage from '../src/Components/Mobile Components/Accounts/OtpVerificationPage';
import LoginSignupPage from '../src/Components/Mobile Components/Accounts/LoginSignupPage';
import ReferralLoginPage from '../src/Components/Mobile Components/Accounts/ReferralLoginPage';
import AccessoriesRelevance from './Components/Accesories/AccesoriesRelevance';
import FilterRelevance from './Components/BikeFilter/FilterRelevance';
import Filter from './Components/BikeFilter/Filter';
import BlogHome from './Components/Blog/BlogHome';
import Category from './Components/Blog/Category';
import SortBy from '../src/Components/Mobile Components/DailyRental/SortBy';
import DateTimeFilter from './Components/Mobile Components/DailyRental/DateTimeFilter';
import MSortBy from '../src/Components/Mobile Components/MontlyRental/MSortBy';
import SideBarFaq from '../src/Components/SideBarLayout/SideBarFaq';
import SidebarAbout from './Components/Mobile Components/About/SidebarAbout';
import MProfileSideBar from '../src/Components/Mobile Components/MyProfileMobileView/MProfileSideBar';
import MRideDetails from '../src/Components/Mobile Components/MyProfileMobileView/MyRide/MRideDetails';
import MobileMyBooking from './Components/Mobile Components/MyProfileMobileView/MyBookings/MobileMyBooking';
import ButtonMoreDetails from './Components/Mobile Components/MyProfileMobileView/MyBookings/ButtonMoreDetails';
import CMoreDetails from '../src/Components/MyProfile/MyBooking/CMoreDetails';

console.log('--------', isMobile);
const desktopRouter = createBrowserRouter([
  {
    path: '/',
    element: <LandingPageLayout />,
    children: [
      { path: '/', element: <Main /> },
      { path: 'daily-rental', element: <DailyRentalComponent /> },
      { path: 'monthly-rental', element: <MontlyRentalComponent /> },
      { path: 'places', element: <Places /> },
      { path: 'membership-card', element: <MembershipCard /> },
      { path: 'booking-summary', element: <BookingSummary /> },
      { path: 'terms', element: <Terms /> },
      { path: 'product', element: <ProductData /> },
      { path: 'next-ride', element: <NextRide /> },
      { path: 'offers', element: <Offer /> },
      { path: 'franchise', element: <FranchiseComponent /> },
      { path: 'contact', element: <ContactComponent /> },
      { path: 'blog', element: <BlogComponent /> },
      { path: 'location', element: <ChooseLocation /> },
      { path: 'filter-component', element: <FilterComponent /> },
      { path: 'accesories-component', element: <AccesoriesComponent /> },
      { path: 'sign-in', element: <SignIn /> },
      { path: 'verify', element: <Verify /> },
      { path: 'login', element: <Login /> },
      { path: 'logout', element: <Logout /> },


      {
        path: 'about',
        element: <Layout />,
        children: [
          { path: '', element: <AboutMOW /> },
          { path: 'trip', element: <YourTrip /> },
          { path: 'payment', element: <Payments /> },
          { path: 'your-booking', element: <YourBooking /> },
          { path: 'wallet-faq', element: <Wallet /> },
          { path: 'refer', element: <Refer /> },

        ],
      },

      {
        path: 'profile',
        element: <ProfileLayout />,
        children: [
          { path: 'myprofile', element: <ProfileComponent /> },
          { path: 'myride', element: <BookingCard /> },
          { path: 'more-details', element: <RideDetails /> },
          { path: 'my-booking', element: <MyBooking /> },
          { path: 'notification', element: <Notification /> },
          { path: 'my-referal', element: <MyReferal /> },
          { path: 'wallet-amt', element: <WalletAmount /> },
          { path: 'more-detail', element: <MoreDetails /> },
          { path: 'c-detail', element: <CMoreDetails /> },
          { path: 'wallet-history', element: <WalletHistory /> }
        ],
      }
    ],
  },
  {
    path: '*',
    element: <LandingPageLayout />
  }

]);
// {
//   path: '*',

//   element: <DashboardDefault />
// }
const mobileRouter = createBrowserRouter([
  {
    path: '/',
    element: <LandingPageLayout />,
    children: [
      { path: '/', element: <Main /> },
      { path: 'login-signup', element: <LoginSignupPage /> },
      { path: 'otp', element: <OtpVerificationPage /> },
      { path: 'login', element: <ReferralLoginPage /> },
      { path: 'mobile-daily-rental', element: <DailyRental /> },
      { path: 'mobile-monthly-rental', element: <MontlyRental /> },
      { path: 'location', element: <ChooseLocation /> },
      { path: 'accesories', element: <AccessoriesRelevance /> },
      { path: 'booking-summary', element: <BookingSummary /> },
      { path: 'product', element: <ProductData /> },
      { path: 'places', element: <Places /> },
      { path: 'membership-card', element: <MembershipCard /> },
      { path: 'terms', element: <Terms /> },
      { path: 'contact', element: <ContactComponent /> },
      { path: 'blog', element: <BlogComponent /> },
      { path: 'franchise', element: <FranchiseComponent /> },
      { path: 'offers', element: <Offer /> },
      { path: 'filter-relevance', element: <FilterRelevance /> },
      { path: 'logout', element: <Logout /> },
      { path: 'sort', element: <SortBy /> },
      { path: 'date', element: <DateTimeFilter /> },
      { path: 'm-sort', element: <MSortBy /> },
      { path: 'p-sidebar', element: <MProfileSideBar /> },
      { path: 'm-mybooking', element: <MobileMyBooking /> },
      { path: 'button-moredetails', element: <ButtonMoreDetails /> },
      { path: 'mobile-moredetails', element: <MobileMoreDetails /> },

    ],
  },

  {
    path: 'about',
    element: <SidebarAbout />,
    children: [
    ],
  },
  {
    path: '*',
    element: <LandingPageLayout />
  }
]);

export const App = () => {
  return (
    <RouterProvider router={isMobile ? mobileRouter : desktopRouter} />

  );
};

export default App

